// @core/api/endpoints/subscription/list_subscriptions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListSubscriptionsResponse,
} from '../../../types/subscription';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/subscription';

/**
 * List subscriptions
 * Returns subscriptions for the tenant with optional filtering by status and plan. Supports pagination and sorting.
 */
export async function ListSubscriptions(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListSubscriptionsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/subscriptions`;
  const requestOptions = options;
  return client.get<ListSubscriptionsResponse>(requestPath, { ...requestOptions, params });
}
